<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">
            <!-- <v-toolbar class="bg-white">
                <v-card-title class="p-0">
                    Multi Transfer
                </v-card-title>
                <v-spacer></v-spacer>
                <div class="custom-icon-wrapper">
                    <v-icon @click="closeMultiTransferForm()">custom-icon mdi-close</v-icon>
                </div>
            </v-toolbar> -->
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        {{$t("res_Label_To")}}*
                    </div>
                    <div class="col-md-3">
                        {{$t("res_Label_Purpose")}}*
                    </div>
                    <div class="col-md-2">
                        {{$t("res_Label_DueDate")}}
                    </div>
                    <div class="col-md-2">
                        {{$t("res_Label_Instruction")}}
                    </div>
                    <div class="col-md-1">
                        
                    </div>
                    <div class="col-md-1">
                        
                    </div>
                </div>
                <div v-for="(item,i) in allTransfers" :key="i">
                    <div class="row">
                        <div class="col-md-3">
                            <StructureUserSelector class="item-min-height"  :showInternalUsers="true" :showExternalUsers="false"
                                :showInternalStructures="true" :showExternalStructures="false" :ignorePermissions="categoryId != 3"
                                :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="item.transferTo"
                                @structureUserSelectChanged="transferToMultipleSelectedChange"
                                :addressBook_header="$t('res_Label_SelectStructureOrUser')">
                            </StructureUserSelector>
                        </div>
                        <div class="col-md-3">
                            <multiselect class="light-bg add-arrow item-min-height" v-model="item.purpose"
                                label="name" track-by="id" open-direction="bottom" :options="purpose_items"
                                :searchable="true" :internal-search="false" :clear-on-select="false"
                                :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                                :hide-selected="false" :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_SelectOption')">
                            </multiselect>
                        </div>
                        <div class="col-md-2">
                            <v-menu content-class="p-0" v-model="item.transfer_date_menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y left min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="utils.dateFormat(item.dueDate)" label=""
                                        v-bind="attrs" v-on="on" solo append-icon="mdi-calendar">
                                        <template v-slot:append>
                                            <v-icon class="item-min-height" v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker :min="nowDate" v-model="item.dueDate" @input="item.transfer_date_menu = false"
                                    ></v-date-picker>
                            </v-menu>
                        </div>
                        <div class="col-md-2">
                            <v-text-field class="text-area item-min-height" v-model="item.instruction" solo></v-text-field>
                        </div>
                        <div class="col-md-1">
                            <div class="row">
                                <div class="col-6" v-if="i==allTransfers.length-1">
                                    <v-btn class="dgs-new-button" @click="addNewRow(item, i)">
                                        <v-icon>mdi-plus-box</v-icon>
                                    </v-btn>
                                </div>
                                <div class="col-6" v-if="allTransfers.length>1">
                                    <v-btn class="dgs-new-button" @click="deleteRow(i)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-1">
                            
                        </div>
                    </div>
                </div>
                <!-- <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="dgs-new-button" @click="closeMultiTransferForm()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" @click="transfer()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions> -->
            </div>
        </div>
        <v-card-actions class="top-shadow gap-3 justify-content-end sticky-actions">
            <v-btn class="light-blue" @click="closeMultiTransferForm()">{{ $t('res_ButtonText_Cancel') }}</v-btn>
            <v-btn @click="transfer()" class="primary">{{ $t('res_ButtonText_Continue') }}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import * as utils from '@/assets/js/common.js'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import Multiselect from 'vue-multiselect'

export default {
    name: 'Multi-Transfer',
    components: { StructureUserSelector, Multiselect },
    props:
    {
        documentId: { type: Number, default: 0 },
        transferId: { type: Number, default: 0 },
        followup:{ type: Boolean, default: false },
        canBeSignedByExternalUser: {type: Boolean, default: false},
        categoryId:{ type: Number, default: 0 }
    },
    data() {
        return {
            constants: constants,
            utils: utils,
            allTransfers: [],
            rowIndex: -1,
            purpose_items: [],
            nowDate: new Date().toISOString().slice(0, 10),
        }
    },
    mounted() 
    {
        this.getAllPurposes();
        this.allTransfers.push({
            documentId: this.documentId,
            transferId: this.transferId,
            transferTo: null,
            purpose: {},
            dueDate: '',
            instruction: '',
            isRowAdded: false,
            transfer_date_menu: false
        });
    },
    watch:
    {
        documentId(){
            this.allTransfers = [];
            this.allTransfers.push({
                documentId: this.documentId,
                transferId: this.transferId,
                transferTo: null,
                purpose: {},
                dueDate: '',
                instruction: '',
                isRowAdded: false,
                transfer_date_menu: false
            });
        }
    },
    methods:
    {
        closeMultiTransferForm()
        {
            this.$emit('closeMultiTransferForm');
        },
        setRowIndex(i){
            this.rowIndex = i;
        },
        transferToMultipleSelectedChange(items){
           let objList = []
           this.allTransfers.map((obj)=>{ if(obj.transferTo&&obj.transferTo!=null&&obj.transferTo.id==items.id){objList.push(obj.transferTo);}});
            if(objList.length==0)
                this.allTransfers[this.allTransfers.length-1].transferTo = this.handleFirstElement(items, {name: 'temp', isTemp: true});
            else
            {
                this.allTransfers[this.allTransfers.length-1].transferTo = {id:0,name:"Select"};;
                window.showAlert(this.$t('res_Msgs_UserAlreadyAdded'), 'warning');
            }
        },
        handleFirstElement(data, tempItem){
            if(data.length > 0) {
                var shouldAddTemp = true;
                for (var i = 0; i<data.length; i++){
                    if(data[i].isTemp 
                        || data[i].id == undefined 
                        || data[i].id == null){
                            shouldAddTemp = false;
                            break;
                    }
                }
                if(shouldAddTemp) {
                    if(tempItem == undefined || tempItem == null){
                        tempItem = {isTemp: true, name: 'temp'};
                    }
                    data = [tempItem, ...data];
                } else if(data.length == 1){
                    data = [];
                }
            }
            return data;
        },
        getAllPurposes() 
        {
            axios.get(constants.baseApiUrl + 'Document/get-all-purposes', { headers: constants.headers })
                .then((res) => 
                {
                    if (res.data != null)
                    {
                        this.purpose_items = res.data;
                    }
                }).catch(err => console.warn(err))
        },
        addNewRow(item,index){
            if(!this.checkRowValid(item)){
                return;
            }
            this.allTransfers[this.allTransfers.length-1].isRowAdded = true;
            this.allTransfers.push({
                documentId: this.documentId,
                transferId: this.transferId,
                transferTo: null,
                purpose: {},
                dueDate: '',
                instruction: '',
                isRowAdded: false,
                transfer_date_menu: false
            });
        },
        checkRowValid(item){
            if(JSON.stringify(item.transferTo) === '{}' || item.transferTo === null || item.transferTo.id === 0){
                window.showAlert(this.$t('res_Msgs_StructureOrUserNeeded'), 'warning');
                return false;
            }
            if(JSON.stringify(item.purpose) === '{}' || item.purpose === null){
                window.showAlert(this.$t('res_Msgs_PurposeNeeded'), 'warning');
                return false;
            }
            return true;
        },
        deleteRow(index){
            this.allTransfers.splice(index, 1);
        },
        transfer(){

            //this loop is to check validation
            var hasNonCc = false;
            for(var i = 0; i< this.allTransfers.length; i++){
                if(i == this.allTransfers.length-1 && this.allTransfers.length > 1){
                    if((JSON.stringify(this.allTransfers[i].transferTo) === '{}' || this.allTransfers[i].transferTo === null || this.allTransfers[i].transferTo.id === 0) && (JSON.stringify(this.allTransfers[i].purpose) === '{}' || this.allTransfers[i].purpose === null))
                    {
                        continue;
                    }
                    else if(!this.checkRowValid(this.allTransfers[i])){
                        return;
                    }
                }
                else if(!this.checkRowValid(this.allTransfers[i])){
                    return;
                }
                if(this.allTransfers[i].purpose.id != 10){
                    hasNonCc = true;
                }
            }
            if(!hasNonCc){
                window.showAlert(this.$t('res_Msgs_AllCc'), 'warning');
                return
            }
            
            var requestBody = [];
            this.allTransfers.forEach(element => {
                var item = {
                    transferId: element.transferId,
                    documentId: element.documentId,
                    forwardTo: [element.transferTo],
                    purpose: element.purpose.id,
                    dueDate: element.dueDate,
                    note: element.instruction,
                    followup:this.followup
                }
                requestBody.push(item);
            });
            window.showLoading();
            axios.post(constants.baseApiUrl + 'Transfer/TransferDocumentList', requestBody, { headers: constants.headers })
                    .then(res => {
                        
                        //;
                        if(res.data == true){
                            this.closeMultiTransferForm();
                            window.showAlert(this.$t('res_Msgs_ChangesSavedSuccess'), 'success')
                        }else if(res.data == false){
                            window.showAlert(this.$t('res_Msgs_NoTransfersCompleted'), 'warning')
                        }else{ //We got a list of forwatdTo Name and Purpose
                            var notCompleted = '';
                            var retData = res.data;
                            for(var i = 0; i< retData.length; i++){
                                var notCompletedPpurpose = this.purpose_items.find(x=>x.id == retData[i].purpose)
                                notCompleted += `name: ${retData[i].name}, purpose: ${notCompletedPpurpose.name}\n`
                            }
                            window.showAlert(this.$t('res_Msgs_NotCompletedTransfers') + "\n" + notCompleted, 'warning')

                            this.closeMultiTransferForm();
                        }

                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading());

        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

    .item-min-height {
        min-height: 45px;
    }

</style> 